import { ReceiptActionType } from "models/actionTypes/receiptActionTypes";
import { ReduxConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

export const receiptCreated = (receipt: WintSuperkollAPIModel.Receipt): ReceiptActionType => {
  return {
    type: ReduxConstants.ReceiptActions.RECEIPT_CREATED,
    payload: receipt,
  };
};

export const receiptUpdated = (receipt: WintSuperkollAPIModel.Receipt): ReceiptActionType => {
  return {
    type: ReduxConstants.ReceiptActions.RECEIPT_UPDATED,
    payload: receipt,
  };
};

export const receiptUpdatedContent = (receipt: WintSuperkollAPIModel.Receipt): ReceiptActionType => {
  return {
    type: ReduxConstants.ReceiptActions.RECEIPT_UPDATED_CONTENT,
    payload: receipt,
  };
};

export const receiptApproved = (receiptId: number): ReceiptActionType => {
  return {
    type: ReduxConstants.ReceiptActions.RECEIPT_APPROVED,
    payload: receiptId,
  };
};

export const receiptSentBack = (receiptId: number): ReceiptActionType => {
  return {
    type: ReduxConstants.ReceiptActions.RECEIPT_SENT_BACK,
    payload: receiptId,
  };
};

export const receiptRemoved = (receiptId: number): ReceiptActionType => {
  return {
    type: ReduxConstants.ReceiptActions.RECEIPT_REMOVED,
    payload: receiptId,
  };
};

export const receiptSnoozed = (receiptId: number): ReceiptActionType => {
  return {
    type: ReduxConstants.ReceiptActions.RECEIPT_SNOOZED,
    payload: receiptId,
  };
};

export const receiptDraftSendIn = (receiptId: number): ReceiptActionType => {
  return {
    type: ReduxConstants.ReceiptActions.RECEIPT_DRAFT_SEND_IN,
    payload: receiptId,
  };
};

export const receiptDraftUpdated = (receipt: WintSuperkollAPIModel.Receipt): ReceiptActionType => {
  return {
    type: ReduxConstants.ReceiptActions.RECEIPT_DRAFT_UPDATED,
    payload: receipt,
  };
};

export const receiptDraftRemoved = (receiptId: number): ReceiptActionType => {
  return {
    type: ReduxConstants.ReceiptActions.RECEIPT_DRAFT_REMOVED,
    payload: receiptId,
  };
};

export const receiptCreatedFromClassification = (classifiedReceiptId: number): ReceiptActionType => {
  return {
    type: ReduxConstants.ReceiptActions.RECEIPT_CREATED_FROM_CLASSIFICATION,
    payload: classifiedReceiptId,
  };
};

export const deleteClassifiedReceipt = (classifiedReceiptId: number): ReceiptActionType => {
  return {
    type: ReduxConstants.ReceiptActions.DELETE_CLASSIFIED_RECEIPT,
    payload: classifiedReceiptId,
  };
};

export const convertClassifiedReceipt = (classifiedReceiptId: number): ReceiptActionType => {
  return {
    type: ReduxConstants.ReceiptActions.CONVERT_CLASSIFIED_RECEIPT,
    payload: classifiedReceiptId,
  };
};

